<mat-accordion [multi]="params.accordion.multi">

  <mat-expansion-panel
    [ngClass]="params.color"
    *ngFor="let panel of params.accordion?.panels"
    [expanded]="panel.expanded">

    <mat-expansion-panel-header>
      <mat-panel-title>
        {{panel.title}}
      </mat-panel-title>
    </mat-expansion-panel-header>


    <ng-container *ngFor="let field of panel.fields;">

      <ng-container *ngIf="field.visible" [service]="service" [field]="field" [group]="form" gioFormField>
      </ng-container>


    </ng-container>

  </mat-expansion-panel>
</mat-accordion>

<!-- action buttons -->
<ng-container *ngIf="params.accordion.buttons">

    <ng-container *ngFor="let button of params.accordion.buttons">

      <ng-container *ngIf="button.visible" [service]="service" [field]="button" [group]="form" gioFormField>
      </ng-container>

    </ng-container>


</ng-container>
